import { IconProps } from "@/common/contracts/icon.contracts";

export const Card = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4330_10518)">
        <path
          d="M20 8.40259H4V6.40259H20M20 18.4026H4V12.4026H20M20 4.40259H4C2.89 4.40259 2 5.29259 2 6.40259V18.4026C2 18.933 2.21071 19.4417 2.58579 19.8168C2.96086 20.1919 3.46957 20.4026 4 20.4026H20C20.5304 20.4026 21.0391 20.1919 21.4142 19.8168C21.7893 19.4417 22 18.933 22 18.4026V6.40259C22 5.29259 21.1 4.40259 20 4.40259Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4330_10518">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.402588)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
